var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutSubHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 641.07 375.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:1.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.38,23.86c-27.59-.85-55.25.94-81.95,7.71-41,10.39-85.74,34.8-103.89,75.05-16.47,36.52-8.11,83.5,14.52,115.35,12.25,17.24,28.25,31.39,43.54,46.01,19.65,18.78,38.79,38.9,62.95,51.37,50.33,25.99,115.98,11.98,156.88-27.2,15.34-14.69,27.55-32.33,38.56-50.5,15.69-25.9,29.42-54.06,31.58-84.27,3.46-48.39-15.49-93.32-60.75-114.72-23.77-11.24-50.3-15.25-76.51-17.38-8.28-.67-16.6-1.17-24.92-1.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.75,120.19c-54.93,28.92-127.48,116.11-78.67,177.91,11.27,14.27,26.9,24.62,43.5,32.06,56.15,25.15,129.9,19.8,172.17-28.37,40.25-45.87,53.03-115.82,15.09-166.51-38.05-50.84-102.35-41.26-152.09-15.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.94,176.03c-34.68,2.23-72.14,15.3-98.76,38.24-12.08,10.41-21.55,24.84-22.49,40.76-.64,10.88,2.74,21.74,8.28,31.13,9.91,16.79,26.36,28.93,44.12,36.97,33.13,15,74.36,23.54,110.48,17.18,76.57-13.47,113.01-122.59,28.33-154.23-22.27-8.32-46.26-11.57-69.97-10.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSubHero);
export default __webpack_public_path__ + "static/media/about_sub_hero.51af6adf81354a5580a021dc0b66a78f.svg";
export { ForwardRef as ReactComponent };